export const LOAD_PROCESS_STATEMENT_RTF_FAILURE = 'LOAD_PROCESS_STATEMENT_RTF_FAILURE';

export const loadProcessStatementRtfFailure = error => ({
    type: LOAD_PROCESS_STATEMENT_RTF_FAILURE,
    payload: error,
    error: true,
});
